import * as types from './mutation-types'
import zoneDevices from '../../services/zoneDevices'
import { createServiceCall } from '../actionsUtil'

export const getPgus = createServiceCall({
  mainAction: types.GET_PGUS_REQUEST,
  serviceFunction: zoneDevices.getPgus,
  successAction: types.GET_PGUS_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_PGUS_FAILURE
})

export const getPlatformGroupDevices = createServiceCall({
  mainAction: types.GET_PG_DEVICES_REQUEST,
  serviceFunction: zoneDevices.getPlatformGroupDevices,
  successAction: types.GET_PG_DEVICES_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_PG_DEVICES_FAILURE
})

export const getTempetatureChartData = createServiceCall({
  mainAction: types.GET_TEMPERATURE_DATA_REQUEST,
  serviceFunction: zoneDevices.getTempetatureChartData,
  successAction: types.GET_TEMPERATURE_DATA_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_TEMPERATURE_DATA_FAILURE
})

export const getHumidityChartData = createServiceCall({
  mainAction: types.GET_HUMIDITY_DATA_REQUEST,
  serviceFunction: zoneDevices.getHumidityChartData,
  successAction: types.GET_HUMIDITY_DATA_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_HUMIDITY_DATA_FAILURE
})

export const getCo2ChartData = createServiceCall({
  mainAction: types.GET_CO_TWO_DATA_REQUEST,
  serviceFunction: zoneDevices.getCo2ChartData,
  successAction: types.GET_CO_TWO_DATA_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_CO_TWO_DATA_FAILURE
})

export const getZoneDevice = createServiceCall({
  mainAction: types.GET_ZONE_DEVICE_REQUEST,
  serviceFunction: zoneDevices.getZoneDevice,
  successAction: types.GET_ZONE_DEVICE_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_ZONE_DEVICE_FAILURE
})

export const getIrrigationZone = createServiceCall({
  mainAction: types.GET_IRRIGATION_ZONE_REQUEST,
  serviceFunction: zoneDevices.getIrrigationZone,
  successAction: types.GET_IRRIGATION_ZONE_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_IRRIGATION_ZONE_FAILURE
})

export const getCO2Zone = createServiceCall({
  mainAction: types.GET_CO2_ZONE_REQUEST,
  serviceFunction: zoneDevices.getCO2Zone,
  successAction: types.GET_CO2_ZONE_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_CO2_ZONE_FAILURE
})

export const getWorkZone = createServiceCall({
  mainAction: types.GET_WORK_ZONE_REQUEST,
  serviceFunction: zoneDevices.getWorkZone,
  successAction: types.GET_WORK_ZONE_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_WORK_ZONE_FAILURE
})

export const getGrowZone = createServiceCall({
  mainAction: types.GET_GROW_ZONE_REQUEST,
  serviceFunction: zoneDevices.getGrowZone,
  successAction: types.GET_GROW_ZONE_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_GROW_ZONE_FAILURE
})
